export default function IbmPartnerSection() {
  return (
    <section id="ibm-power" className="py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          <div className="order-2 lg:order-1">
            <span className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-4 py-1.5 rounded-full text-xs font-semibold uppercase tracking-wider">
              <i className="ri-verified-badge-line"></i> IBM Partner
            </span>
            <h2 className="text-3xl md:text-5xl font-bold mt-5 text-foreground-950 leading-tight">
              Deep roots in IBM Power and enterprise storage
            </h2>
            <p className="text-foreground-700 mt-5 leading-relaxed">
              Our engineers have spent decades inside IBM Power environments — AIX, IBM i, and Linux on Power —
              along with the storage and SAN fabrics that feed them. When your core business applications live on
              Power, you want a partner who already knows the platform, not one learning it on your dime.
            </p>
            <p className="text-foreground-600 mt-4 leading-relaxed text-sm">
              As an IBM Partner we work directly with IBM and our distribution channels on licensing, hardware
              sourcing, and support escalations, so our clients get enterprise-grade pricing and technical resources
              backed by IBM itself. We&apos;re actively growing that partnership and moving toward IBM Silver Partner
              status — a credential earned through demonstrated platform expertise, not a marketing line.
            </p>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {[
                { icon: 'ri-cpu-line', title: 'Power9, Power10, Power11', desc: 'Upgrade planning, migration, and lifecycle support.' },
                { icon: 'ri-terminal-box-line', title: 'AIX & IBM i', desc: 'Patching, PTFs, tuning, and modernization work.' },
                { icon: 'ri-hard-drive-2-line', title: 'Storage Fabrics', desc: 'SAN design, zoning, replication, and tiering.' },
                { icon: 'ri-refresh-line', title: 'Refresh Projects', desc: 'Consolidation to cut footprint, power, and cost.' },
              ].map((c) => (
                <div key={c.title} className="bg-background-50 border border-background-200 rounded-lg p-5">
                  <div className="w-11 h-11 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                    <i className={`${c.icon} text-xl`}></i>
                  </div>
                  <div className="font-semibold text-foreground-950 mt-4">{c.title}</div>
                  <div className="text-foreground-600 text-sm mt-1">{c.desc}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="order-1 lg:order-2 relative">
            <img
              src="https://readdy.ai/api/search-image?query=Enterprise%20data%20center%20server%20racks%20with%20blue%20and%20teal%20indicator%20lights%20blurred%20in%20soft%20focus%2C%20clean%20modern%20IT%20infrastructure%20photography%2C%20organized%20cabling%20and%20storage%20arrays%2C%20cool%20professional%20lighting%20with%20dark%20neutral%20background%2C%20high%20detail%20editorial%20corporate%20composition&width=1200&height=1100&seq=acu-ibm-power-01&orientation=squarish"
              className="w-full h-[520px] object-cover object-top rounded-lg"
              alt="IBM Power and storage infrastructure managed by Acu-Comp"
            />
            <div className="absolute -bottom-6 -left-6 bg-accent-500 text-foreground-950 rounded-lg p-6 max-w-xs hidden md:block">
              <div className="text-2xl font-bold">Power + Storage</div>
              <div className="text-sm mt-1">AIX, IBM i, and Linux on Power — IBM Partner expertise, Silver Partner
                status on the way.</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}